<template>
  <div class="gifts-list-page">
    <div class="gift-details app-container">
      <div class="global-header-wrap">
        <!--<h3>
          礼品活动详情
        </h3>
        <div>
          <button class="global-button-style" @click="$router.back()">
            {{ $t("commonMsg.back") }}
          </button>
          <button class="global-button-style">
            <a href="/static/docs/user.xlsx" download="用户信息模板" target="_blank">{{ $t("commonMsg.downLoadForecast") }}</a>
          </button>
          <button class="global-button-style" @click="addCode">
            <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
          </button>
        </div>-->

        <div class="user-header-left">
          <div class="left-part">
            <span>{{ $t("user.username") }}</span>
            <div class="listSearch">
              <el-input
                v-model="userName"
                clearable
                @keyup.enter.native="search"
                @clear="clearSearch('userName')"
                :placeholder="$t('placeholder.enter')"
              >
              </el-input>
            </div>
          </div>
          <div class="left-part">
            <span>{{ $t("user.phone") }}</span>
            <div class="listSearch">
              <el-input
                v-model="phone"
                clearable
                @keyup.enter.native="search"
                @clear="clearSearch('phone')"
                :placeholder="$t('placeholder.enter')"
              >
              </el-input>
            </div>
          </div>
          <div class="left-part">
            <span>{{ $t("user.giftCode") }}</span>
            <div class="listSearch">
              <el-input
                v-model="code"
                clearable
                @keyup.enter.native="search"
                @clear="clearSearch('code')"
                :placeholder="$t('placeholder.enter')"
              >
              </el-input>
            </div>
          </div>
          <button class="global-button-style" @click="search">
            {{ $t("commonMsg.search") }}
          </button>
        </div>
        <div class="right-part">
          <button class="global-button-style" @click="$router.back()">
            {{ $t("commonMsg.back") }}
          </button>
          <button class="global-button-style">
            <a
              href="/static/docs/user.xlsx"
              download="用户信息模板"
              target="_blank"
              >{{ $t("commonMsg.downLoadForecast") }}</a
            >
          </button>
          <button class="global-button-style" @click="addCode">
            <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
          </button>
        </div>
      </div>

      <el-card class="app-table-container" :body-style="{ padding: '20px' }">
        <!-- <div slot="header">
          <div class="global-table-header">
            <div class="orgList-header-btn-left">
              <list-search ref="listSearch" @listSearchEvn="listSearchEvn" />
            </div>
            <div class="gift-details-btn">
              <button class="global-button-style" @click="addOrg">
                {{ $t("org.addOrg") }}
              </button>
              <button class="global-button-style">
                {{ $t("org.exportTag") }}
              </button>
            </div>          </div>
        </div> -->
        <div class="global-body-wrap">
          <div style="margin-bottom: 15px;" v-if="cards.length">
            <el-table
              :data="cards"
              :header-cell-style="tableHeaderColor"
              style="width: 100%;height: 100%;overflow-y: scroll;"
            >
              <el-table-column
                type="index"
                align="center"
                fixed="left"
                label="序号"
                :key="Math.random()"
                width="50"
              >
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="title" align="center" label="卡包">
              </el-table-column>
              <el-table-column prop="allCount" align="center" label="总数">
              </el-table-column>
              <el-table-column
                prop="thisUsed"
                align="center"
                label="本活动使用"
              >
              </el-table-column>
              <el-table-column prop="unUsed" align="center" label="未派发">
              </el-table-column>
              <el-table-column prop="used" align="center" label="已派发">
              </el-table-column>
              <el-table-column prop="deled" align="center" label="删除数">
              </el-table-column>
            </el-table>
          </div>

          <appTable
            :tableData="tableData"
            :tableProps="tableProps"
            :currentPage="params.page"
            :pageSize="params.limit"
            @tableHandle="tableHandle"
          />
        </div>
        <pagination
          :pageSize="params.limit"
          :total="total"
          @pageNum="pageNum"
          @pageSize="pageSize"
          :pageSizes="true"
        />
      </el-card>

      <!-- ============= 新增 & 编辑弹窗 =============== -->
      <el-dialog
        :title="title"
        :visible.sync="codeHandle"
        width="800px"
        center
        @close="closeDialog"
      >
        <div>
          <el-form
            label-width="80px"
            :model="gift"
            @submit.native.prevent
            ref="ruleForm"
            :rules="rules"
          >
            <div v-if="title === '新增'">
              <el-form-item :label="'用户'">
                <div>
                  <el-upload
                    class="fl"
                    ref="uploader"
                    action=""
                    :auto-upload="false"
                    :on-change="importPhone"
                    :show-file-list="false"
                    style="float: left"
                  >
                    <span class="gift-mgt-fileName" v-if="userFile">{{
                      userFile.name
                    }}</span>
                    <el-button size="small" type="primary">导入</el-button>
                  </el-upload>
                  <span class="hand-add-btn fl" @click="usersFlag = !usersFlag"
                    >手动添加</span
                  >
                </div>

                <ul class="parms-list" v-show="usersFlag">
                  <li v-for="(item, index) in users" :key="index">
                    <input type="text" v-model="item.key" placeholder="名称" />
                    <input
                      type="text"
                      v-model="item.value"
                      :id="item.id"
                      :ref="item.id"
                      placeholder="手机号"
                    />
                    <span
                      v-if="index === users.length - 1"
                      @click="addParam"
                      title="添加项"
                      ><i class="el-icon-plus"></i
                    ></span>
                    <span
                      v-if="index > 0"
                      @click="deleteParam(users, item.id)"
                      title="删除项"
                      ><i class="el-icon-minus"></i
                    ></span>
                  </li>
                </ul>
              </el-form-item>
              <el-form-item :label="'选择卡片'">
                <el-checkbox-group v-model="cardHolders" @change="changeCheck">
                  <el-checkbox
                    :label="item.id"
                    v-for="(item, index) in useList"
                    :key="index"
                    :name="'check' + index"
                    >{{ item.lable }}({{ item.value }})</el-checkbox
                  >
                </el-checkbox-group>
                <span v-if="useList.length === 0">暂无</span>
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item :label="'手机号码'">
                <el-input
                  v-model="gift.phone"
                  class="fl"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item :label="'礼品卡号'" v-if="!isSales">
                <el-input
                  v-model="gift.code"
                  class="fl"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item :label="'密码'" v-if="!isSales">
                <el-input
                  v-model="gift.password"
                  class="fl"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item :label="'验证码'" v-if="!isSales">
                <el-input
                  v-model="gift.verifyCode"
                  class="fl"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <span slot="footer">
          <el-button @click="codeHandle = false">取 消</el-button>
          <el-button type="primary" @click="codeEvn('ruleForm')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- ============= ============== =============== -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import listSearch from "@/components/listSearch";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
export default {
  components: {
    listSearch,
    appTable,
    pagination
  },
  mixins: [listMixin],
  computed: {
    ...mapGetters(["appendPopup", "userInfo"]),
    tableProps() {
      let tableProps = [
        {
          prop: "phone",
          label: this.$t("user.phone")
        },
        {
          prop: "user.name",
          obj: true,
          label: "用户名"
        },
        {
          prop: "code",
          label: this.$t("sale.gift.giftCard")
        },
        {
          prop: "password",
          label: "密码"
        },
        {
          prop: "verifyCode",
          label: "验证码"
        },
        {
          prop: "actived",
          label: "领取"
        },
        {
          prop: "outAt",
          label: "派发日期"
        },
        {
          prop: "card_status",
          label: this.$t("commonMsg.status")
        },
        {
          width: 200,
          prop: "giftDetailsHandle",
          label: this.$t("org.manage")
        }
      ];
      return tableProps;
    }
  },
  data() {
    return {
      gift: {
        code: "",
        phone: "",
        password: "",
        verifyCode: ""
      },
      cardHolders: [],
      cards: [],
      userFile: null,
      codeFile: null,
      useList: [],
      params: {
        limit: 20,
        page: 1,
        sortBy: "updatedAt",
        giftCard: this.$route.query.id
      },

      tableData: [],
      total: 0,
      title: "",
      giftCodeItem: null,
      codeHandle: false,
      rules: {
        codeList: [
          {
            required: true,
            message: "礼品卡号不能为空",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "礼品卡号不能为空",
            trigger: "blur"
          }
        ]
      },
      users: [
        {
          id: String(Math.random()).substring(2, 12),
          key: "",
          value: ""
        }
      ],
      usersFlag: false,
      isSales: false,

      userName: "", // 用户名称
      phone: "", // 手机卡号
      code: "" // 礼品卡号
    };
  },
  created() {
    this.getUseList();
  },
  methods: {
    addParam() {
      const obj = {
        id: String(Math.random()).substring(2, 12),
        key: "",
        value: ""
      };
      this.users.push(obj);
    },

    deleteParam(arr, id) {
      arr.map((item, i) => {
        if (item.id === id) {
          arr.splice(i, 1);
        }
      });
    },

    importGiftCard(file) {
      this.codeFile = file;
    },
    importPhone(file) {
      this.userFile = file;
    },

    getList() {
      this.$http.getGiftCode(this.params).then(res => {
        this.tableData = res.data.results;
        this.total = res.data.count;
        this.cards = res.data.cardHolders;
      });
    },

    getUseList() {
      this.useList = [];
      this.$http.getUseList().then(ret => {
        ret.data.map(item => {
          let obj = {
            lable: item.title,
            value: item.cardCount,
            id: item._id
          };
          this.useList.push(obj);
        });
      });
    },

    changeCheck() {},

    addCode() {
      this.title = "新增";
      this.codeHandle = true;
      this.usersFlag = false;
      this.users = [
        {
          id: String(Math.random()).substring(2, 12),
          key: "",
          value: ""
        }
      ];
    },

    codeEvn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.title === "新增") {
            this.create();
          } else {
            this.editCode();
          }
        } else {
          return false;
        }
      });
    },

    toGiftHistory(data) {
      this.$router.push({
        name: "historyGift",
        query: { id: data.row._id }
      });
    },

    edit(data) {
      this.giftCodeItem = data.row;
      this.gift.code = data.row.code;
      this.gift.phone = data.row.phone;
      this.gift.password = data.row.password;
      this.gift.verifyCode = data.row.verifyCode;
      this.title = "编辑";
      this.codeHandle = true;

      if (this.userInfo.roleValue !== 1) {
        // 不是管理员
        this.isSales = true;
      }
    },

    create() {
      let params = {
        user: this.userFile ? this.userFile.raw : ""
      };
      params.id = this.$route.query.id;
      params.cardHolders = this.cardHolders;

      let users = [];
      let stop = true;
      this.users.map(item => {
        if (!/\d{7,11}$/.test(item.value) && item.value.trim().length > 1) {
          this.elMsg("手机号格式有误", "warning");
          document.getElementById(item.id).focus();
          stop = false;
        }

        let obj = {
          name: item.key,
          phone: item.value.trim()
        };
        users.push(obj);
      });

      let form = new FormData();
      let keys = Object.keys(params);
      keys.forEach(key => {
        if (key === "cardHolders") {
          form.append("cardHolders", this.cardHolders);
        } else {
          form.append(key, params[key]);
        }
      });

      form.append("users", JSON.stringify(users));

      if (!stop) return;

      this.$http
        .createGiftCode(form)
        .then(res => {
          this.codeHandle = false;
          this.usersFlag = false;
          this.userFile = null;
          this.$refs.uploader.clearFiles();

          this.users = [
            {
              id: String(Math.random()).substring(2, 12),
              key: "",
              value: ""
            }
          ];
          this.elMsg(this.$t("alertMsg.addSuccess"), "success");
          this.getList();
          this.getUseList();
        })
        .catch(err => {
          let response = JSON.parse(JSON.stringify(err)).response.data;
          this.elMsg(response.message, "warning");
        });
    },

    editCode() {
      let params = {};
      params.phone = this.gift.phone.trim();
      params.code = this.gift.code;
      params.password = this.gift.password;
      params.verifyCode = this.gift.verifyCode;

      if (this.userInfo.roleValue !== 1) {
        // 不是管理员
        delete params.code;
        delete params.password;
        delete params.verifyCode;
      }

      this.$http
        .updateGiftCode(this.giftCodeItem._id, params)
        .then(res => {
          this.codeHandle = false;
          this.elMsg(this.$t("alertMsg.editSuccess"), "success");
          this.getList();
        })
        .catch(err => {
          this.elMsg(err.response.data.message, "error");
        });
    },

    toDetails(data) {
      this.giftCodeItem = data.row;
    },

    recovery(data) {
      // 回收
      this.$http
        .recoveryGiftCode({ id: data.row._id })
        .then(res => {
          this.elMsg(this.$t("alertMsg.recoverySuccess"), "success");
          this.getList();
        })
        .catch(err => {
          this.elMsg(err.response.data.message, "error");
        });
    },

    del(data) {
      this.$http
        .delGiftCode(data.row._id)
        .then(res => {
          this.elMsg(this.$t("alertMsg.delSuccess"), "success");
          this.getList();
        })
        .catch(err => {
          this.elMsg(err.response.data.message, "error");
        });
    },
    pageNum(page) {
      this.params.page = page;
      this.getList();
    },

    pageSize(size) {
      this.params.limit = size;
      this.getList();
    },

    search() {
      // this.userName ? (this.params['user.name'] = this.userName) : "";
      // this.code ? (this.params.code = this.code) : "";
      // this.phone ? (this.params.phone = this.phone) : "";

      if (this.userName) {
        this.params["user.name"] = this.userName;
      } else {
        delete this.params["user.name"];
      }

      if (this.phone) {
        this.params.phone = this.phone;
      } else {
        delete this.params.phone;
      }

      if (this.code) {
        this.params.code = this.code;
      } else {
        delete this.params.code;
      }

      this.getList();
    },

    clearSearch(type) {
      switch (type) {
        case "userName":
          this.userName = "";
          delete this.params["user.name"];
          break;
        case "phone":
          this.phone = "";
          delete this.params.phone;
          break;
        case "code":
          this.code = "";
          delete this.params.code;
          break;
        default:
          break;
      }
      this.getList();
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f7f7f7;font-weight: 500;";
      }
    },

    closeDialog() {
      this.cardHolders = [];
      for (let i in this.gift) {
        this.gift[i] = "";
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.gift-details-header {
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    // margin-right:10px;
  }
}
.gift-details-pagination {
  padding: 10px;
  text-align: right;
}
.gift-import-btn {
  margin-top: 10px;
}
.gift-mgt-fileName {
  margin-right: 10px;
}
.hand-add-btn {
  background-color: #56a3fd;
  border-radius: 3px;
  padding: 0px 12px;
  margin-left: 10px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  height: 32px;
  &:hover {
    background-color: #5bbbff;
  }
}
.gifts-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.user-header-left {
  width: calc(100% - 300px);
  float: left;
}
.global-button-style {
  margin-top: 20px;
  margin-left: 0;
}
.left-part {
  float: left;
  margin-right: 20px;
  .listSearch {
    .el-input {
      width: 150px;
      .search-icon {
        font-size: 22px;
        cursor: pointer;
      }
    }
  }
  > span {
    margin-right: 10px;
    font-size: 14px;
  }
  .global-button-style {
    margin: 0;
  }
}
.right-part {
  .global-button-style {
    margin-left: 10px;
  }
}
.card-title {
  color: #555;
  margin-bottom: 8px;
}
</style>
